"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converters = exports.toSecondsMultipliers = exports.VIEWS = void 0;
exports.VIEWS = ['weeks', 'days', 'hours', 'minutes', 'seconds'];
exports.toSecondsMultipliers = {
    seconds: 1,
    minutes: 60,
    hours: 60 * 60,
    days: 60 * 60 * 24,
    weeks: 60 * 60 * 24 * 7
};
var createConverter = function (from) {
    var converter = {};
    for (var i = 0; i < exports.VIEWS.length; i++) {
        var to = exports.VIEWS[i];
        converter[to] = exports.toSecondsMultipliers[from] / exports.toSecondsMultipliers[to];
    }
    return converter;
};
exports.converters = exports.VIEWS.reduce(function (converters, view) {
    converters[view] = createConverter(view);
    return converters;
}, {});
